import styled from "styled-components";

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const Container = styled.div`
  width: 100%;
  transition: transform 167ms cubic-bezier(0.33, 0, 0, 1) 0s;
  transform-origin: center center;
  display: grid;
  gap: 1.5rem;
  max-width: 30rem;
  margin: auto;
  height: 100%;
`;
